<div style="display: flex; width: 100vw; height: 100dvh; justify-content: center; align-items: center; box-sizing: border-box;" >
    <reset-password-token></reset-password-token>
</div>